// src/theme/Theme.js
import colors from './colors';

export const Theme = {
  container: {
    minHeight: '100vh',
    width: '100vw',
    padding: 20,
    boxSizing: 'border-box',
    background: 'var(--bg-auth-container)',
    display: 'flex',            // Added this
    alignItems: 'center',
    justifyContent: 'center',
  },
  headings: {
    fontFamily: 'PlusJakartaSans-SemiBold, sans-serif',
    fontSize: 24,
    color: colors.mainTextColor,
  },
  modalHeadings: {
    fontFamily: 'PlusJakartaSans-SemiBold, sans-serif',
    fontSize: 18,
    color: colors.mainTextColor,
  },
  miniHeadings: {
    fontFamily: 'PlusJakartaSans-SemiBold, sans-serif',
    fontSize: 14,
    color: colors.mainTextColor,
  },
  modalDescription: {
    fontFamily: 'PlusJakartaSans-Regular, sans-serif',
    fontSize: 14,
    color: colors.subTextColor,
  },

  errorText: {
    fontFamily: 'PlusJakartaSans-Regular, sans-serif',
    fontSize: 12,
    color: colors.danger,
    marginBottom: 8,
    marginLeft: 4,
  },
  font12: {
    fontFamily: 'PlusJakartaSans-Regular, sans-serif',
    fontSize: 12,
    color: colors.mainTextColor,
  },
  font10Regular: {
    fontFamily: 'PlusJakartaSans-Regular, sans-serif',
    fontSize: 10,
    color: colors.mainTextColor,
  },
  font13Regular: {
    fontFamily: 'PlusJakartaSans-Regular, sans-serif',
    fontSize: 13,
    color: colors.mainTextColor,
  },
  font16Medium: {
    fontFamily: 'PlusJakartaSans-Medium, sans-serif',
    fontSize: 16,
    color: colors.subTextColor,
  },
  font16SemiBold: {
    fontFamily: 'PlusJakartaSans-SemiBold, sans-serif',
    fontSize: 16,
    color: colors.mainTextColor,
  },
  font24SemiBold: {
    fontFamily: 'PlusJakartaSans-SemiBold, sans-serif',
    fontSize: 24,
    color: colors.mainTextColor,
  },
  font28SemiBold: {
    fontFamily: 'PlusJakartaSans-SemiBold, sans-serif',
    fontSize: 28,
    color: colors.mainTextColor,
  },
  font15SemiBold: {
    fontFamily: 'PlusJakartaSans-SemiBold, sans-serif',
    fontSize: 15,
    color: colors.mainTextColor,
  },
  font16Regular: {
    fontFamily: 'PlusJakartaSans-Regular, sans-serif',
    fontSize: 16,
    color: colors.mainTextColor,
  },
  font14SemiBold: {
    fontFamily: 'PlusJakartaSans-SemiBold, sans-serif',
    fontSize: 14,
    color: colors.mainTextColor,
  },
  font14Regular: {
    fontFamily: 'PlusJakartaSans-Regular, sans-serif',
    fontSize: 14,
    color: colors.mainTextColor,
  },
  font12Regular: {
    fontFamily: 'PlusJakartaSans-Regular, sans-serif',
    fontSize: 12,
    color: colors.mainTextColor,
  },
  font14Medium: {
    fontFamily: 'PlusJakartaSans-Medium, sans-serif',
    fontSize: 14,
    color: colors.mainTextColor,
  },
  font18SemiBold: {
    fontFamily: 'PlusJakartaSans-SemiBold, sans-serif',
    fontSize: 18,
    color: colors.mainTextColor,
  },
  font17SemiBold: {
    fontFamily: 'PlusJakartaSans-SemiBold, sans-serif',
    fontSize: 17,
    color: colors.mainTextColor,
  },
  font12SemiBold: {
    fontFamily: 'PlusJakartaSans-SemiBold, sans-serif',
    fontSize: 12,
    color: colors.mainTextColor,
  },
  font12Medium: {
    fontFamily: 'PlusJakartaSans-Medium, sans-serif',
    fontSize: 12,
    color: colors.mainTextColor,
  },
  font20SemiBold: {
    fontFamily: 'PlusJakartaSans-SemiBold, sans-serif',
    fontSize: 20,
    color: colors.mainTextColor,
  },
  font36SemiBold: {
    fontFamily: 'PlusJakartaSans-SemiBold, sans-serif',
    fontSize: 36,
    color: colors.mainTextColor,
  },
  font30SemiBold: {
    fontFamily: 'PlusJakartaSans-SemiBold, sans-serif',
    fontSize: 30,
    color: colors.mainTextColor,
  },
  font32SemiBold: {
    fontFamily: 'PlusJakartaSans-SemiBold, sans-serif',
    fontSize: 32,
    color: colors.mainTextColor,
  },
};
